<template>
  <div>
    <div class="header-tra-cuu">
      <span class="ml-3">Vị trí tàu tại cảng</span>
    </div>
    <div style="display: flex;">
      <!-- <span style="margin: 8px 8px 0px 10px;">
        Ngày: 
      </span>
      <v-menu
        ref="menuTopTau"
        :close-on-content-click="false"
        v-model="menuTopTauAll"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        :style="{}"
        style="margin-top: 8px;"
        max-width="290px"
        min-width="290px"
        >
        <v-text-field
        slot="activator"
        v-model="searchTopTauAll"
        persistent-hint
        class="pb-0 my-0"
        ></v-text-field>
        <v-date-picker v-model="dateSearchTopTauAll" no-title @input="menuTopTauAll = false"></v-date-picker>
      </v-menu>
      <v-icon size="17" style="margin-left: 10px; cursor: pointer;" @click="menuTopTauAll = !menuTopTauAll">date_range</v-icon> -->

      <v-text-field
        clearable
        class="pt-1 pl-2"
        style="width: 170px; flex: none;"
        v-model="nameOfShip"
        placeholder="Nhập tên tàu"
        @keyup.enter="loadData()"
      ></v-text-field>
      <v-btn flat small class="ml-0 mr-2 py-0 my-0" @click="loadData()" style="text-transform: none; color: #1d52e8;"> <v-icon size="17">search</v-icon> Tìm kiếm</v-btn>
    </div>
    <content-placeholders v-if="loadingTableAnchorage">
      <content-placeholders-img />
      <content-placeholders-heading />
    </content-placeholders>
    <!-- <ejs-grid v-else ref="grid" :dataSource='itemsDsTauAll' :allowGrouping='true' :rowSelected='rowSelected' :groupSettings='groupOptions' height='400px' width='100%'>
      <e-columns>
        <e-column field='nameOfShip' headerText='Tên tàu' textAlign='Center' width=120></e-column>
        <e-column field='portHarbourName' headerText='' textAlign='Center' width=120></e-column>
        <e-column field='flagStateOfShipName' headerText='Quốc tịch' textAlign='Center' width=100></e-column>
        <e-column field='portHarbourPortWharf' headerText='Cầu/ phao' textAlign='Center' width=200></e-column>
        <e-column field='anchoringDateFrom' headerText='Ngày/ giờ vào cầu' textAlign='Center' width=110></e-column>
        <e-column field='anchoringDateTo' headerText='Ngày/ giờ rời cầu' textAlign='Center' width=110></e-column>
      </e-columns>
    </ejs-grid> -->

    <vue-good-table
      v-else
      ref="myCustomTable"
      :columns="headers"
      :rows="itemsDsTauAll"
      :groupOptions="{
        enabled: true,
        expand: true
      }"
    >
    </vue-good-table>
  </div>
</template>
<script>
import Vue from 'vue'
import { GridPlugin, Group } from '@syncfusion/ej2-vue-grids'
Vue.use(GridPlugin)
const groupBy = key => array =>
array.reduce((objectsByKeyValue, obj) => {
  const value = obj[key]
  objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
  return objectsByKeyValue
}, {})
export default {
  props: {
  },
  components: {
  },
  provide: {
    grid: [Group]
  },
  data: () => ({
    headers: [
      {
        label: 'Tên tàu',
        field: 'nameOfShip',
        width: '16%'
      },
      {
        label: 'Quốc tịch',
        field: 'flagStateOfShipName',
        width: '10%'
      },
      {
        label: 'Trọng tải',
        field: 'dwt'
      },
      {
        label: 'Chiều dài',
        field: 'loa'
      },
      {
        label: 'Dung tích',
        field: 'gt'
      },
      {
        label: 'Cầu/ phao',
        field: 'portHarbourPortWharf',
        width: '17%'
      },
      {
        label: 'Thời gian bắt đầu neo',
        field: 'anchoringDateFrom'
      },
      {
        label: 'Thời gian kết thúc neo',
        field: 'anchoringDateTo'
      }
    ],
    nameOfShip: '',
    itemsDsTauAll: [],
    groupOptions: { columns: ['portHarbourName'] },
    searchTopTauAll: '',
    menuTopTauAll: false,
    dateSearchTopTauAll: '',
    loadingTableAnchorage: false,
    maritimeCode: 0
  }),
  watch: {
    dateSearchTopTauAll (val) {
      this.searchTopTauAll = this.parseDate(val)
      this.loadData()
    }
  },
  computed: {
  },
  created () {
    let vm = this
    // vm.loadData()
    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(result => {
        vm.getCurentDate()
      })
    })
  },
  mounted () {
    this.$refs.myCustomTable.expandAll()
  },
  methods: {
    getCurentDate () {
      let date = new Date()
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    },
    loadMaritimeCode: function (query) {
      var vm = this
      let param = {
      }
      param['isDelete'] = 0
      param['start'] = -1
      param['end'] = -1
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0
            resolve(result[0])
          } else {
            resolve({})
          }
        }).catch(function (xhr) {
          console.log(xhr)
          reject(false)
        })
      })
    },
    parseDate (date) {
      if (!date) return null
      console.log(date.split('-'))
      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    loadData () {
      let vm = this
      vm.loadingTableAnchorage = true
      // anchoringDateFrom: vm.searchTopTauAll
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        let url = resultInit['getVmaScheduleAnchorage_Port_URL']
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          flag: true,
          start: -1,
          shipPosition: 2,
          maritimeCode: vm.maritimeCode,
          nameOfShip: vm.nameOfShip,
          end: -1
        }).then(result => {
          vm.loadingTableAnchorage = false
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableAll = false
            result['data'] = result['data'].map(item => {
              item['portHarbourPortWharf'] = item['portHarbourShortName'] + ', ' + item['portWharfShortName']
              return item
            }) || []
            let groupByPortHarbourName = groupBy('portHarbourName')
            let dataTmp = groupByPortHarbourName(result['data'])
            let dataConvert = []
            for (var key in dataTmp) {
              dataConvert.push({
                mode: 'span',
                label: key,
                html: false,
                children: dataTmp[key]
              })
            }
            vm.itemsDsTauAll = dataConvert
            console.log('dataConvert++++++++++++++++', dataConvert)
          } else {
            vm.itemsDsTauAll = []
          }
        }).catch(xhr => {
          vm.loadingTableAnchorage = false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ViTriTauTaiCang.vue?86cd15aa